import { render, staticRenderFns } from "./sale-item-mobile.vue?vue&type=template&id=d4fe94c2"
import script from "./sale-item-mobile.vue?vue&type=script&lang=js"
export * from "./sale-item-mobile.vue?vue&type=script&lang=js"
import style0 from "./sale-item-mobile.vue?vue&type=style&index=0&id=d4fe94c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports